import api from '../../common/api';

const initialState = () => ({
  permission: {
    userCanViewAdminPanel: true,
    userCanCreateDiagnostic: true,
  },
  userCanViewAdminPanel: true,
  libraryCompetencies: [],
  libraryCases: [],
  libraryCasesLoading: false,
  caseEditModal: {
    show: false,
    id: null,
  },
  currentCase: null,
  currentCaseLoading: false,
  libraryNotes: [],
  libraryNotesLoading: false,
  noteEditModal: {
    show: false,
    id: null,
  },
  currentNote: null,
  currentNoteLoading: false,
  presetsRoles: [],
  diagnostics: {
    filters: {},
    sorts: {},
    pagination: {},
    items: [],
  },
  currentDetailDiagnostic: {
    detail: {},
  },
  // State Modal
  // competency
  competenciesModal: false,
  competenceComments: {},
  competencyEditModal: {
    show: false,
    id: null,
  },
  currentCompetency: null,
  currentCompetencyLoading: false,
  // preset
  presetModal: false,
  presetEditModal: {
    show: false,
    id: null,
  },
  currentPreset: null,
  currentPresetsLoading: true,

  notification: {
    show: false,
    success: true,
    message: '',
  },

  checklistCreating: false,

  checklists: [],
  checklistsLoading: false,
  checklistCandidates: {},

  currentChecklist: null,
  currentChecklistLoading: false,
  currentChecklistCandidate: null,
  currentChecklistManager: null,
  currentChecklistResult: null,

  idpItems: [],
  idpLoading: false,

  reportModules: [
    {
      key: 'show_comments',
      label: 'Комментарии эксперта',
      description: 'Комментарии по индикаторам',
    },
    {
      key: 'show_graphs',
      label: 'Графики',
      description: 'Визуализация профиля компетенций',
    },
    {
      key: 'show_idp',
      label: 'Индивидуальный план развития',
      description: 'Таблица ИПР',
    },
    {
      key: 'show_conclusion',
      label: 'Итоговый комментарий',
      description: 'Итоговый комментарий эксперта',
    },
    {
      key: 'show_result_notes',
      label: 'Итоги ассессора',
      description: 'Блок Сильные / Зоны роста / Рекомендации',
    },
    {
      key: 'show_competence_notes',
      label: 'Описание компетенций',
      description: 'Описательные элементы к компетенциям',
    },
  ],
});

// Создаёт checklist-competence из шаблона библиотеки вместе с её маркерами.
// Общая логика для createChecklist (массовое создание при заведении чеклиста)
// и addChecklistCompetence (добавление одной компетенции в уже созданный чеклист).
async function createChecklistCompetenceFromTemplate(checklistId, template) {
  const competence = await api.post('/management-diagnostics/checklist-competences/', {
    checklist: checklistId,
    name: template.name,
    description: template.description || '',
    category: template.category,
    level_tags: template.level_tags || [],
    source_competence_template: template.id,
  });

  const markerRequests = (template.markers || []).map(marker =>
    api.post('/management-diagnostics/checklist-markers/', {
      competence: competence.id,
      name: marker.name,
      level_0_description: marker.level_0_description || '',
      level_1_description: marker.level_1_description || '',
      level_2_description: marker.level_2_description || '',
      level_3_description: marker.level_3_description || '',
      source_marker_template: marker.id,
    }));
  await Promise.all(markerRequests);

  return competence;
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    // Competence
    async loadCompetenciesLibrary({ commit }) {
      try {
        const response = await api.get('/management-diagnostics/library/competence-templates/');
        commit('SET_COMPETENCIES', response);
      } catch (err) {
        return err;
      }
    },
    async createCompetency({
                             commit,
                             dispatch,
                           }, payload) {
      try {
        commit('SET_CURRENT_COMPETENCY_LOADING', true);
        const response = await api.post('/management-diagnostics/library/competence-templates/', payload);
        await dispatch('addIndicatorInCompetency', {
          indicators: payload.indicators,
          competency: response,
        });
        await dispatch('loadCompetenciesLibrary');
        commit('SET_COMPETENCY_ID_MODAL', null);
        commit('SET_CURRENT_COMPETENCY', null);
        commit('SET_COMPETENCY_SHOW_MODAL', false);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Компетенция успешно создана',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось создать компетенцию. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_COMPETENCY_LOADING', false);
      }
    },
    async updateCompetency({
                             commit,
                             dispatch,
                             state,
                           }, payload) {
      try {
        commit('SET_CURRENT_COMPETENCY_LOADING', true);
        const { id } = state.competencyEditModal;

        // 1. Обновляем саму компетенцию
        await api.put(`/management-diagnostics/library/competence-templates/${id}/`, {
          name: payload.name,
          description: payload.description,
          category: payload.category,
          level_tags: payload.levels,
          order: 0,
        });

        // 2. Определяем оригинальные индикаторы (те что были до редактирования)
        const original = state.currentCompetency?.markers || [];
        const updatedIds = new Set(payload.indicators.filter(i => i.id)
          .map(i => i.id));

        const requests = [];

        // 3. Обновляем / создаём индикаторы
        payload.indicators.forEach((indicator) => {
          const body = {
            competence: id,
            name: indicator.name,
            level_0_description: indicator.levels[0],
            level_1_description: indicator.levels[1],
            level_2_description: indicator.levels[2],
            level_3_description: indicator.levels[3],
            order: 0,
          };
          if (indicator.id) {
            requests.push(api.put(`/management-diagnostics/library/marker-templates/${indicator.id}/`, body));
          } else {
            requests.push(api.post('/management-diagnostics/library/marker-templates/', body));
          }
        });

        // 4. Удаляем индикаторы которые убрали из формы
        original.forEach((marker) => {
          if (!updatedIds.has(marker.id)) {
            requests.push(api.delete(`/management-diagnostics/library/marker-templates/${marker.id}/`));
          }
        });

        await Promise.all(requests);
        await dispatch('loadCompetenciesLibrary');

        commit('SET_COMPETENCY_ID_MODAL', null);
        commit('SET_CURRENT_COMPETENCY', null);
        commit('SET_COMPETENCY_SHOW_MODAL', false);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Компетенция успешно обновлена',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить компетенцию. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_COMPETENCY_LOADING', false);
      }
    },
    async deleteItemCompetency({
                                 commit,
                                 dispatch,
                               }, id) {
      try {
        await api.delete(`/management-diagnostics/library/competence-templates/${id}/`);
        await dispatch('loadCompetenciesLibrary');
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Компетенция успешно удалена',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить компетенцию. Попробуйте позже.',
        });
      }
    },
    async addIndicatorInCompetency(_, {
      indicators,
      competency,
    }) {
      if (indicators && indicators.length) {
        const requests = indicators.map((indicator) => {
          const payload = {
            competence: competency.id,
            name: indicator.name,
            level_0_description: indicator.levels[0],
            level_1_description: indicator.levels[1],
            level_2_description: indicator.levels[2],
            level_3_description: indicator.levels[3],
            order: 0,
          };
          return api.post('/management-diagnostics/library/marker-templates/', payload);
        });
        await Promise.all(requests);
      }
    },
    async openEditCompetency({
                               commit,
                               state,
                             }, id) {
      // 1. Сразу открываем модалку и фиксируем id
      commit('SET_COMPETENCY_ID_MODAL', id);
      commit('SET_COMPETENCY_SHOW_MODAL', true);
      commit('SET_CURRENT_COMPETENCY_LOADING', true);
      commit('SET_CURRENT_COMPETENCY', null);

      try {
        // 2. Запрос на бэк за полными данными

        // const response = await fetch(`/api/competencies/${id}`);
        const response = state.libraryCompetencies.find((item) => item.id === id);
        if (response) {
          commit('SET_CURRENT_COMPETENCY', response);
        }
        // const data = await response.json();
        // 3. Кладём данные в стор — модалка подхватит через getter
      } catch (e) {
        commit('SET_COMPETENCY_SHOW_MODAL', false);
        commit('SET_COMPETENCY_ID_MODAL', null);
      } finally {
        commit('SET_CURRENT_COMPETENCY_LOADING', false);
      }
    },
    async openCreateCompetency({ commit }) {
      try {
        commit('SET_COMPETENCY_ID_MODAL', null);
        commit('SET_COMPETENCY_SHOW_MODAL', true);
        commit('SET_CURRENT_COMPETENCY_LOADING', true);
        commit('SET_CURRENT_COMPETENCY', null);
      } catch (e) {
        commit('SET_COMPETENCY_SHOW_MODAL', false);
      } finally {
        commit('SET_CURRENT_COMPETENCY_LOADING', false);
      }
    },

    // Checklist
    async createChecklist({
                            state,
                            commit,
                          }, payload) {
      try {
        commit('SET_CHECKLIST_CREATING', true);

        // 1. Создаём чек-лист.
        // Бэк валидирует "либо candidate, либо candidate_name" и отклоняет
        // пустой candidate_name — поэтому шлём ровно один из двух ключей.
        const checklistPayload = {
          manager: payload.manager,
          company: payload.company,
          position: payload.position,
        };
        if (payload.candidate) {
          checklistPayload.candidate = payload.candidate;
        } else {
          checklistPayload.candidate_name = (payload.candidate_name || '').trim();
        }
        const checklist = await api.post('/management-diagnostics/checklists/', checklistPayload);

        // 2. Для каждой компетенции: создаём checklist-competence, затем её маркеры
        const createdCompetences = await Promise.all(
          (payload.competencies || []).map(async (template) => {
            const competence = await createChecklistCompetenceFromTemplate(checklist.id, template);
            return {
              templateId: template.id,
              competenceId: competence.id,
            };
          }),
        );

        // 3. Добавляем выбранные пользователем кейсы
        if (payload.cases && payload.cases.length) {
          const caseRequests = payload.cases
            .map(caseTemplate => {
              const comp = createdCompetences.find(c => c.templateId === caseTemplate.competence);
              if (!comp) return null;
              return api.post('/management-diagnostics/checklist-cases/', {
                competence: comp.competenceId,
                name: caseTemplate.name,
                description: caseTemplate.description || '',
                source_case_template: caseTemplate.id,
              });
            })
            .filter(Boolean);
          if (caseRequests.length) await Promise.all(caseRequests);
        }

        // 5. Отправляем настройки отчёта
        const selectedKeys = new Set(payload.selectedReportModuleKeys || []);
        const settingsPayload = {
          checklist: checklist.id,
          ...state.reportModules.reduce((acc, module) => {
            acc[module.key] = selectedKeys.has(module.key);
            return acc;
          }, {}),
        };
        await api.post('/management-diagnostics/result-settings/', settingsPayload);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Диагностика успешно создана',
        });
        return checklist;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось создать диагностику. Попробуйте позже.',
        });
        throw err;
      } finally {
        commit('SET_CHECKLIST_CREATING', false);
      }
    },

    async loadChecklists({ commit }) {
      commit('SET_CHECKLISTS_LOADING', true);
      try {
        const response = await api.get('/management-diagnostics/checklists/');
        const checklists = Array.isArray(response) ? response : [];
        commit('SET_CHECKLISTS', checklists);

        const uniqueIds = [...new Set(checklists.map(c => c.candidate)
          .filter(Boolean))];
        const results = await Promise.allSettled(
          uniqueIds.map(id => api.get(`/users/candidates/${id}/`)),
        );
        const candidatesMap = {};
        results.forEach((result, i) => {
          if (result.status === 'fulfilled') {
            candidatesMap[uniqueIds[i]] = result.value;
          }
        });
        commit('SET_CHECKLIST_CANDIDATES', candidatesMap);
      } catch (_err) {
        // silent
      } finally {
        commit('SET_CHECKLISTS_LOADING', false);
      }
    },

    async loadChecklist({ commit }, id) {
      commit('SET_CURRENT_CHECKLIST_LOADING', true);
      commit('SET_CURRENT_CHECKLIST', null);
      commit('SET_CURRENT_CHECKLIST_CANDIDATE', null);
      commit('SET_CURRENT_CHECKLIST_MANAGER', null);
      commit('SET_CURRENT_CHECKLIST_RESULT', null);
      try {
        const checklist = await api.get(`/management-diagnostics/checklists/${id}/`);
        commit('SET_CURRENT_CHECKLIST', checklist);
        if (checklist.candidate) {
          try {
            const candidate = await api.get(`/users/candidates/${checklist.candidate}/`);
            commit('SET_CURRENT_CHECKLIST_CANDIDATE', candidate);
          } catch (_) { /* кандидат может быть недоступен */
          }
        }
        if (checklist.manager) {
          try {
            const manager = await api.get(`/users/managers/${checklist.manager}/`);
            commit('SET_CURRENT_CHECKLIST_MANAGER', manager);
          } catch (_) { /* эксперт может быть недоступен */
          }
        }
        // Если результат уже есть — загружаем оценки
        if (checklist.results && checklist.results.length) {
          try {
            const result = await api.get(`/management-diagnostics/results/${checklist.results[0].id}/`);
            commit('SET_CURRENT_CHECKLIST_RESULT', result);
          } catch (_) { /* результат недоступен */
          }
        }
      } catch (_err) {
        // silent
      } finally {
        commit('SET_CURRENT_CHECKLIST_LOADING', false);
      }
    },

    async updateChecklist({ state, commit }, {
      id,
      data,
      silent = false,
    }) {
      try {
        const updated = await api.patch(`/management-diagnostics/checklists/${id}/`, data);
        // Обновляем только изменённые поля, не перезагружая чек-лист целиком,
        // иначе сбросится текущий результат и несохранённые оценки в UI.
        // candidate и candidate_name взаимоисключающие. Вызывающий код (participantPayload)
        // всегда шлёт оба ключа явно (активный со значением, второй — пустым/null),
        // поэтому ответ бэка (source) уже содержит корректное состояние обоих полей —
        // ручного обнуления здесь больше не требуется.
        const source = updated && typeof updated === 'object' ? updated : data;
        const merged = {
          ...state.currentChecklist,
          ...source,
        };
        commit('SET_CURRENT_CHECKLIST', merged);

        if ('candidate' in data || 'candidate_name' in data) {
          if (merged.candidate) {
            try {
              const candidate = await api.get(`/users/candidates/${merged.candidate}/`);
              commit('SET_CURRENT_CHECKLIST_CANDIDATE', candidate);
            } catch (_) { /* кандидат может быть недоступен */
            }
          } else {
            commit('SET_CURRENT_CHECKLIST_CANDIDATE', null);
          }
        }

        if ('manager' in data) {
          if (merged.manager) {
            try {
              const manager = await api.get(`/users/managers/${merged.manager}/`);
              commit('SET_CURRENT_CHECKLIST_MANAGER', manager);
            } catch (_) { /* эксперт может быть недоступен */
            }
          } else {
            commit('SET_CURRENT_CHECKLIST_MANAGER', null);
          }
        }
        if (!silent) {
          commit('SET_NOTIFICATION', {
            show: true,
            success: true,
            message: 'Данные диагностики обновлены',
          });
        }
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить данные диагностики. Попробуйте позже.',
        });
        throw err;
      }
    },

    async createChecklistResult({ commit }, checklistId) {
      try {
        const result = await api.post('/management-diagnostics/results/', { checklist: checklistId });
        commit('SET_CURRENT_CHECKLIST_RESULT', result);
        return result;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось создать результат. Попробуйте позже.',
        });
        throw err;
      }
    },

    async bulkEvaluate({ commit }, {
      id,
      evaluations,
    }) {
      try {
        const result = await api.post(`/management-diagnostics/results/${id}/bulk-evaluate/`, { evaluations });
        commit('SET_CURRENT_CHECKLIST_RESULT', result);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Оценки сохранены',
        });
        return result;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось сохранить оценки. Попробуйте позже.',
        });
        throw err;
      }
    },
    async updateResult({ commit }, {
      resultId,
      data,
    }) {
      try {
        const result = await api.patch(`/management-diagnostics/results/${resultId}/`, data);
        commit('SET_CURRENT_CHECKLIST_RESULT', result);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Результаты обновлены',
        });
        return result;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить результаты. Попробуйте позже.',
        });
        throw err;
      }
    },
    async completeResult({ commit }, resultId) {
      try {
        const result = await api.patch(`/management-diagnostics/results/${resultId}/`, { completion_status: 'completed' });
        commit('SET_CURRENT_CHECKLIST_RESULT', result);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Диагностика завершена',
        });
        return result;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось завершить диагностику. Попробуйте позже.',
        });
        throw err;
      }
    },

    async deleteChecklist({
                            commit,
                            dispatch,
                          }, id) {
      try {
        await api.delete(`/management-diagnostics/checklists/${id}/`);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Диагностика успешно удалена',
        });
        dispatch('loadChecklists');
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить диагностику. Попробуйте позже.',
        });
      }
    },

    // Case templates
    async loadCasesLibrary({ commit }) {
      commit('SET_CASES_LOADING', true);
      try {
        const response = await api.get('/management-diagnostics/library/case-templates/');
        commit('SET_CASES', Array.isArray(response) ? response : []);
      } catch (err) {
        return err;
      } finally {
        commit('SET_CASES_LOADING', false);
      }
    },
    async createCaseTemplate({
                               commit,
                               dispatch,
                             }, payload) {
      try {
        commit('SET_CURRENT_CASE_LOADING', true);
        await api.post('/management-diagnostics/library/case-templates/', payload);
        await dispatch('loadCasesLibrary');
        commit('SET_CASE_SHOW_MODAL', false);
        commit('SET_CURRENT_CASE', null);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Кейс успешно создан',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось создать кейс. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_CASE_LOADING', false);
      }
    },
    async updateCaseTemplate({
                               commit,
                               dispatch,
                               state,
                             }, payload) {
      try {
        commit('SET_CURRENT_CASE_LOADING', true);
        const { id } = state.caseEditModal;
        await api.put(`/management-diagnostics/library/case-templates/${id}/`, payload);
        await dispatch('loadCasesLibrary');
        commit('SET_CASE_SHOW_MODAL', false);
        commit('SET_CASE_ID_MODAL', null);
        commit('SET_CURRENT_CASE', null);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Кейс успешно обновлён',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить кейс. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_CASE_LOADING', false);
      }
    },
    async deleteCaseTemplate({
                               commit,
                               dispatch,
                             }, id) {
      try {
        await api.delete(`/management-diagnostics/library/case-templates/${id}/`);
        await dispatch('loadCasesLibrary');
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Кейс успешно удалён',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить кейс. Попробуйте позже.',
        });
      }
    },
    async openEditCase({
                         commit,
                         state,
                       }, id) {
      commit('SET_CURRENT_CASE_LOADING', true);
      commit('SET_CURRENT_CASE', null);
      try {
        const found = state.libraryCases.find(c => c.id === id);
        if (found) commit('SET_CURRENT_CASE', found);
        commit('SET_CASE_ID_MODAL', id);
        commit('SET_CASE_SHOW_MODAL', true);
      } catch (e) {
        commit('SET_CASE_SHOW_MODAL', false);
        commit('SET_CASE_ID_MODAL', null);
      } finally {
        commit('SET_CURRENT_CASE_LOADING', false);
      }
    },
    async openCreateCase({ commit }) {
      commit('SET_CASE_ID_MODAL', null);
      commit('SET_CURRENT_CASE', null);
      commit('SET_CASE_SHOW_MODAL', true);
    },

    // Note templates (strength / growth_area / recommendation)
    async loadNotesLibrary({ commit }) {
      commit('SET_NOTES_LOADING', true);
      try {
        const response = await api.get('/management-diagnostics/library/note-templates/');
        commit('SET_NOTES', Array.isArray(response) ? response : []);
      } catch (err) {
        return err;
      } finally {
        commit('SET_NOTES_LOADING', false);
      }
    },
    async createNoteTemplate({
                               commit,
                               dispatch,
                             }, payload) {
      try {
        commit('SET_CURRENT_NOTE_LOADING', true);
        await api.post('/management-diagnostics/library/note-templates/', payload);
        await dispatch('loadNotesLibrary');
        commit('SET_NOTE_SHOW_MODAL', false);
        commit('SET_CURRENT_NOTE', null);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Шаблон заметки успешно создан',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось создать шаблон. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_NOTE_LOADING', false);
      }
    },
    async updateNoteTemplate({
                               commit,
                               dispatch,
                               state,
                             }, payload) {
      try {
        commit('SET_CURRENT_NOTE_LOADING', true);
        const { id } = state.noteEditModal;
        await api.put(`/management-diagnostics/library/note-templates/${id}/`, payload);
        await dispatch('loadNotesLibrary');
        commit('SET_NOTE_SHOW_MODAL', false);
        commit('SET_NOTE_ID_MODAL', null);
        commit('SET_CURRENT_NOTE', null);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Шаблон заметки успешно обновлён',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить шаблон. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_NOTE_LOADING', false);
      }
    },
    async deleteNoteTemplate({
                               commit,
                               dispatch,
                             }, id) {
      try {
        await api.delete(`/management-diagnostics/library/note-templates/${id}/`);
        await dispatch('loadNotesLibrary');
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Шаблон заметки успешно удалён',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить шаблон. Попробуйте позже.',
        });
      }
    },
    async openEditNote({
                         commit,
                         state,
                       }, id) {
      commit('SET_CURRENT_NOTE_LOADING', true);
      commit('SET_CURRENT_NOTE', null);
      try {
        const found = state.libraryNotes.find(n => n.id === id);
        if (found) commit('SET_CURRENT_NOTE', found);
        commit('SET_NOTE_ID_MODAL', id);
        commit('SET_NOTE_SHOW_MODAL', true);
      } catch (e) {
        commit('SET_NOTE_SHOW_MODAL', false);
        commit('SET_NOTE_ID_MODAL', null);
      } finally {
        commit('SET_CURRENT_NOTE_LOADING', false);
      }
    },
    async openCreateNote({ commit }) {
      commit('SET_NOTE_ID_MODAL', null);
      commit('SET_CURRENT_NOTE', null);
      commit('SET_NOTE_SHOW_MODAL', true);
    },

    // Preset
    async loadPresetsRoles({ commit }) {
      try {
        const response = await api.get('/management-diagnostics/presets/');
        commit('SET_PRESETS_ROLES', response);
      } catch (err) {
        return err;
      }
    },
    async createPreset({ commit }, payload) {
      try {
        commit('SET_CURRENT_PRESET_LOADING', true);
        await api.post('/management-diagnostics/presets/', payload);
        await commit('SET_CURRENT_PRESET', null);
        commit('SET_PRESET_SHOW_MODAL', false);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Пресет успешно создан',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось создать пресет. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_PRESET_LOADING', false);
      }
    },
    async updatePreset({
                         commit,
                         dispatch,
                         state,
                       }, payload) {
      try {
        commit('SET_CURRENT_PRESET_LOADING', true);
        const { id } = state.presetEditModal;
        await api.put(`/management-diagnostics/presets/${id}/`, payload);
        await dispatch('loadPresetsRoles');
        commit('SET_CURRENT_PRESET', null);
        commit('SET_PRESET_SHOW_MODAL', false);
        commit('SET_PRESET_ID_MODAL', null);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Пресет успешно обновлён',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить пресет. Попробуйте позже.',
        });
      } finally {
        commit('SET_CURRENT_PRESET_LOADING', false);
      }
    },
    async deletePreset({
                         commit,
                         dispatch,
                       }, id) {
      try {
        await api.delete(`/management-diagnostics/presets/${id}/`);
        await dispatch('loadPresetsRoles');
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Пресет успешно удалён',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить пресет. Попробуйте позже.',
        });
      }
    },
    async openEditPreset({
                           commit,
                           state,
                         }, id) {
      commit('SET_CURRENT_PRESET_LOADING', true);
      commit('SET_CURRENT_PRESET', null);

      try {
        const response = state.presetsRoles.find((item) => item.id === id);
        if (response) {
          commit('SET_CURRENT_PRESET', response);
        }
        commit('SET_PRESET_ID_MODAL', id);
        commit('SET_PRESET_SHOW_MODAL', true);
      } catch (e) {
        commit('SET_PRESET_SHOW_MODAL', false);
        commit('SET_PRESET_ID_MODAL', null);
      } finally {
        commit('SET_CURRENT_PRESET_LOADING', false);
      }
    },
    async openCreatePreset({ commit }) {
      try {
        commit('SET_PRESET_ID_MODAL', null);
        commit('SET_PRESET_SHOW_MODAL', true);
        commit('SET_CURRENT_PRESET_LOADING', true);
        commit('SET_CURRENT_PRESET', null);
      } catch (e) {
        commit('SET_PRESET_SHOW_MODAL', false);
      } finally {
        commit('SET_CURRENT_PRESET_LOADING', false);
      }
    },

    // Result notes — individual records per item (source_note_template or custom)
    async saveResultNotes({
                            commit,
                            state,
                          }, {
                            resultId,
                            kinds,
                          }) {
      // kinds: { strength: { templateIds: [], customTexts: [] }, growth_area: ..., recommendation: ... }
      try {
        const existing = state.currentChecklistResult?.notes || [];

        // Delete all existing notes
        if (existing.length) {
          await Promise.all(
            existing.map(n => api.delete(`/management-diagnostics/result-notes/${n.id}/`)),
          );
        }

        // Recreate from desired state
        const creates = [];
        let order = 0;
        for (const [kind, {
          templateIds,
          customTexts
        }] of Object.entries(kinds)) {
          for (const templateId of (templateIds || [])) {
            const tmpl = (state.libraryNotes || []).find(n => n.id === templateId);
            if (tmpl) {
              creates.push(api.post('/management-diagnostics/result-notes/', {
                result: resultId,
                kind,
                text: tmpl.text,
                source_note_template: templateId,
                order,
              }));
              order += 1;
            }
          }
          for (const text of (customTexts || [])) {
            const trimmed = (text || '').trim();
            if (trimmed) {
              creates.push(api.post('/management-diagnostics/result-notes/', {
                result: resultId,
                kind,
                text: trimmed,
                order,
              }));
              order += 1;
            }
          }
        }

        if (creates.length) await Promise.all(creates);

        const updatedResult = await api.get(`/management-diagnostics/results/${resultId}/`);
        commit('SET_CURRENT_CHECKLIST_RESULT', updatedResult);
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось сохранить заметки. Попробуйте позже.',
        });
        throw err;
      }
    },
    async saveCompetenceComment(_, {
      id,
      comment,
    }) {
      await api.patch(`/management-diagnostics/checklist-competences/${id}/`, { comment });
    },

    async saveCompetenceNotes({
                                commit,
                                state,
                              }, {
                                competenceId,
                                existingNotes,
                                kinds,
                              }) {
      try {
        if (existingNotes && existingNotes.length) {
          await Promise.all(
            existingNotes.map(n => api.delete(`/management-diagnostics/competence-notes/${n.id}/`)),
          );
        }
        const creates = [];
        let order = 0;
        for (const [kind, {
          templateIds,
          customTexts
        }] of Object.entries(kinds)) {
          for (const templateId of (templateIds || [])) {
            const tmpl = (state.libraryNotes || []).find(n => n.id === templateId);
            if (tmpl) {
              creates.push(api.post('/management-diagnostics/competence-notes/', {
                competence: competenceId,
                kind,
                text: tmpl.text,
                source_note_template: templateId,
                order,
              }));
              order += 1;
            }
          }
          for (const text of (customTexts || [])) {
            const trimmed = (text || '').trim();
            if (trimmed) {
              creates.push(api.post('/management-diagnostics/competence-notes/', {
                competence: competenceId,
                kind,
                text: trimmed,
                order,
              }));
              order += 1;
            }
          }
        }
        return creates.length ? await Promise.all(creates) : [];
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось сохранить заметки компетенции. Попробуйте позже.',
        });
        throw err;
      }
    },

    async addChecklistCase(_, {
      competenceId,
      name,
      description,
      sourceCaseTemplateId,
    }) {
      return api.post('/management-diagnostics/checklist-cases/', {
        competence: competenceId,
        name,
        description: description || '',
        ...(sourceCaseTemplateId ? { source_case_template: sourceCaseTemplateId } : {}),
      });
    },

    async removeChecklistCase(_, { caseId }) {
      await api.delete(`/management-diagnostics/checklist-cases/${caseId}/`);
    },

    async addChecklistCompetence({ commit }, { checklistId, template }) {
      try {
        const competence = await createChecklistCompetenceFromTemplate(checklistId, template);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Компетенция добавлена в чек-лист',
        });
        return competence;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось добавить компетенцию. Попробуйте позже.',
        });
        throw err;
      }
    },

    async deleteChecklistCompetence({ commit }, id) {
      try {
        await api.delete(`/management-diagnostics/checklist-competences/${id}/`);
        commit('REMOVE_CHECKLIST_COMPETENCE', id);
        commit('SET_NOTIFICATION', {
          show: true,
          success: true,
          message: 'Компетенция успешно удалена из чек-листа',
        });
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить компетенцию. Попробуйте позже.',
        });
        throw err;
      }
    },

    // Принимает компетенции уже в новом порядке и сохраняет order = индекс в массиве.
    // Обновляем локальный стейт сразу (оптимистично), чтобы drag-n-drop не дёргался.
    // PATCH-запросы шлём в два прохода: сначала уводим все order в заведомо не
    // пересекающийся с финальным диапазоном (0..n-1) положительный офсет, и только потом
    // проставляем финальные значения — иначе при параллельных запросах в какой-то момент
    // две компетенции могут оказаться с одинаковым order (бэк может это отклонить, если
    // order уникален в рамках чек-листа). Отрицательные order бэк не принимает.
    async reorderChecklistCompetences({ commit }, orderedCompetences) {
      commit('SET_CHECKLIST_COMPETENCES', orderedCompetences);
      const TEMP_ORDER_OFFSET = 100000;
      try {
        await Promise.all(orderedCompetences.map((comp, index) =>
          api.patch(`/management-diagnostics/checklist-competences/${comp.id}/`, { order: TEMP_ORDER_OFFSET + index })));
        await Promise.all(orderedCompetences.map((comp, index) =>
          api.patch(`/management-diagnostics/checklist-competences/${comp.id}/`, { order: index })));
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось сохранить порядок компетенций. Попробуйте позже.',
        });
        throw err;
      }
    },

    // IDP
    async loadIdpItems({ commit }) {
      commit('SET_IDP_LOADING', true);
      try {
        const response = await api.get('/management-diagnostics/individual-development-plans/');
        commit('SET_IDP_ITEMS', Array.isArray(response) ? response : []);
      } catch (_) {
        // silent
      } finally {
        commit('SET_IDP_LOADING', false);
      }
    },

    async createIdpItem({ commit }, payload) {
      try {
        const item = await api.post('/management-diagnostics/individual-development-plans/', payload);
        commit('ADD_IDP_ITEM', item);
        return item;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось добавить пункт ИПР. Попробуйте позже.',
        });
        throw err;
      }
    },

    async updateIdpItem({ commit }, {
      id,
      ...data
    }) {
      try {
        const item = await api.patch(`/management-diagnostics/individual-development-plans/${id}/`, data);
        commit('UPDATE_IDP_ITEM', item);
        return item;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось обновить пункт ИПР. Попробуйте позже.',
        });
        throw err;
      }
    },

    async removeIdpItem({ commit }, id) {
      try {
        await api.delete(`/management-diagnostics/individual-development-plans/${id}/`);
        commit('REMOVE_IDP_ITEM', id);
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось удалить пункт ИПР. Попробуйте позже.',
        });
        throw err;
      }
    },

    async updateResultSettings({
                                 commit,
                                 state,
                               }, selectedKeys) {
      const settings = state.currentChecklistResult?.checklist_result_settings;
      if (!settings) return;
      const payload = Object.fromEntries(
        state.reportModules.map(m => [m.key, selectedKeys.includes(m.key)]),
      );
      const updated = await api.patch(`/management-diagnostics/result-settings/${settings.id}/`, payload);
      commit('SET_CHECKLIST_RESULT_SETTINGS', updated);
    },

    async generateDiagnosticPdf({ commit }, { resultId, ...payload }) {
      try {
        const data = await api.post(
          `/management-diagnostics/results/${resultId}/download-pdf/`,
          payload,
        );
        return data;
      } catch (err) {
        commit('SET_NOTIFICATION', {
          show: true,
          success: false,
          message: 'Не удалось сформировать PDF-отчёт. Попробуйте позже.',
        });
        throw err;
      }
    },

  },
  mutations: {
    SET_COMPETENCIES_MODAL(state, value) {
      state.competenciesModal = value;
    },
    SET_COMPETENCY_SHOW_MODAL(state, value) {
      state.competencyEditModal.show = value;
    },
    SET_COMPETENCY_ID_MODAL(state, id) {
      state.competencyEditModal.id = id;
    },
    SET_CURRENT_COMPETENCY(state, data) {
      state.currentCompetency = data;
    },
    SET_CURRENT_COMPETENCY_LOADING(state, value) {
      state.currentCompetencyLoading = value;
    },
    SET_COMPETENCIES(state, competencies) {
      state.libraryCompetencies = competencies;
    },

    SET_CASES(state, items) {
      state.libraryCases = items;
    },
    SET_CASES_LOADING(state, value) {
      state.libraryCasesLoading = value;
    },
    SET_CASE_SHOW_MODAL(state, value) {
      state.caseEditModal.show = value;
    },
    SET_CASE_ID_MODAL(state, id) {
      state.caseEditModal.id = id;
    },
    SET_CURRENT_CASE(state, data) {
      state.currentCase = data;
    },
    SET_CURRENT_CASE_LOADING(state, value) {
      state.currentCaseLoading = value;
    },
    SET_NOTES(state, items) {
      state.libraryNotes = items;
    },
    SET_NOTES_LOADING(state, value) {
      state.libraryNotesLoading = value;
    },
    SET_NOTE_SHOW_MODAL(state, value) {
      state.noteEditModal.show = value;
    },
    SET_NOTE_ID_MODAL(state, id) {
      state.noteEditModal.id = id;
    },
    SET_CURRENT_NOTE(state, data) {
      state.currentNote = data;
    },
    SET_CURRENT_NOTE_LOADING(state, value) {
      state.currentNoteLoading = value;
    },
    SET_PRESET_SHOW_MODAL(state, value) {
      state.presetEditModal.show = value;
    },
    SET_PRESET_ID_MODAL(state, id) {
      state.presetEditModal.id = id;
    },
    SET_CURRENT_PRESET(state, data) {
      state.currentPreset = data;
    },
    SET_CURRENT_PRESET_LOADING(state, value) {
      state.currentPresetsLoading = value;
    },
    SET_PRESETS_ROLES(state, presets) {
      state.presetsRoles = presets;
    },
    SET_NOTIFICATION(state, {
      show,
      success,
      message,
    }) {
      state.notification = {
        show,
        success,
        message,
      };
    },
    SET_CHECKLIST_CREATING(state, value) {
      state.checklistCreating = value;
    },
    SET_CHECKLISTS(state, items) {
      state.checklists = items;
    },
    SET_CHECKLISTS_LOADING(state, value) {
      state.checklistsLoading = value;
    },
    SET_CHECKLIST_CANDIDATES(state, map) {
      state.checklistCandidates = map;
    },
    SET_CURRENT_CHECKLIST(state, data) {
      state.currentChecklist = data;
    },
    SET_CURRENT_CHECKLIST_LOADING(state, value) {
      state.currentChecklistLoading = value;
    },
    SET_CURRENT_CHECKLIST_CANDIDATE(state, data) {
      state.currentChecklistCandidate = data;
    },
    SET_CURRENT_CHECKLIST_MANAGER(state, data) {
      state.currentChecklistManager = data;
    },
    SET_CURRENT_CHECKLIST_RESULT(state, data) {
      state.currentChecklistResult = data;
    },
    SET_COMPETENCE_COMMENT(state, {
      competenceId,
      comment,
    }) {
      state.competenceComments = {
        ...state.competenceComments,
        [competenceId]: comment,
      };
    },
    SET_IDP_ITEMS(state, items) {
      state.idpItems = items;
    },
    SET_IDP_LOADING(state, value) {
      state.idpLoading = value;
    },
    ADD_IDP_ITEM(state, item) {
      state.idpItems.push(item);
    },
    UPDATE_IDP_ITEM(state, item) {
      const i = state.idpItems.findIndex(x => x.id === item.id);
      if (i !== -1) state.idpItems.splice(i, 1, item);
    },
    REMOVE_IDP_ITEM(state, id) {
      state.idpItems = state.idpItems.filter(x => x.id !== id);
    },

    REMOVE_CHECKLIST_COMPETENCE(state, id) {
      if (state.currentChecklist && state.currentChecklist.competences) {
        state.currentChecklist.competences = state.currentChecklist.competences.filter(c => c.id !== id);
      }
    },

    SET_CHECKLIST_COMPETENCES(state, competences) {
      if (state.currentChecklist) {
        state.currentChecklist.competences = competences;
      }
    },

    SET_CHECKLIST_RESULT_SETTINGS(state, data) {
      if (state.currentChecklistResult) {
        state.currentChecklistResult = {
          ...state.currentChecklistResult,
          checklist_result_settings: data,
        };
      }
    },

  },
  getters: {
    allDiagnostic: (state) => state.diagnostics,
    libraryCompetencies: (state) => state.libraryCompetencies,

    competenciesModal: (state) => state.competenciesModal,
    competencyEditModal: (state) => state.competencyEditModal,
    currentCompetency: (state) => state.currentCompetency,
    currentCompetencyLoading: (state) => state.currentCompetencyLoading,

    libraryCases: (state) => state.libraryCases,
    libraryCasesLoading: (state) => state.libraryCasesLoading,
    caseEditModal: (state) => state.caseEditModal,
    currentCase: (state) => state.currentCase,
    currentCaseLoading: (state) => state.currentCaseLoading,
    libraryNotes: (state) => state.libraryNotes,
    libraryNotesLoading: (state) => state.libraryNotesLoading,
    noteEditModal: (state) => state.noteEditModal,
    currentNote: (state) => state.currentNote,
    currentNoteLoading: (state) => state.currentNoteLoading,
    presetsRoles: (state) => state.presetsRoles,
    presetEditModal: (state) => state.presetEditModal,
    currentPreset: (state) => state.currentPreset,
    currentPresetLoading: (state) => state.currentPresetsLoading,

    notification: (state) => state.notification,
    checklistCreating: (state) => state.checklistCreating,
    checklists: (state) => state.checklists,
    checklistsLoading: (state) => state.checklistsLoading,
    checklistCandidates: (state) => state.checklistCandidates,
    currentChecklist: (state) => state.currentChecklist,
    currentChecklistLoading: (state) => state.currentChecklistLoading,
    currentChecklistCandidate: (state) => state.currentChecklistCandidate,
    currentChecklistManager: (state) => state.currentChecklistManager,
    currentChecklistResult: (state) => state.currentChecklistResult,
    competenceComments: (state) => state.competenceComments,
    reportModules: (state) => state.reportModules,

    currentChecklistResultSettings: (state) => state.currentChecklistResult?.checklist_result_settings ?? null,

    idpItems: (state) => state.idpItems,
    idpLoading: (state) => state.idpLoading,
  },
};
